import { apiClient } from "@/api/api-client";
import { ApiResponse } from "@/types/api-response";
import { OrderResponse } from "@/types/order-type";
import type { PosCartItem } from "@/pages/pos/hooks/use-pos-cart";

export interface CreatePosOrderRequest {
  customerId?: string;
  customerName?: string;
  customerPhone?: string;
  customerAddress?: string;
  items: { variantId: string; quantity: number }[];
}

const DEFAULT_POS_CUSTOMER_ID = "1";

export async function createPosOrder(
  items: PosCartItem[],
  customerName: string,
  customerPhone: string,
  customerId?: string,
  customerAddress?: string
): Promise<ApiResponse<OrderResponse>> {
  const request: CreatePosOrderRequest = {
    customerId: customerId ?? DEFAULT_POS_CUSTOMER_ID,
    customerName,
    customerPhone,
    customerAddress: customerAddress?.trim() || undefined,
    items: items.map((item) => ({
      variantId: item.variantId,
      quantity: item.quantity,
    })),
  };

  return apiClient.post<OrderResponse, CreatePosOrderRequest>(
    "/pos/orders",
    request
  );
}
